<template>
    <v-container fluid>
        <v-row class="mx-0">
            <v-col cols="12" md="6" class="py-0">
                <a :href="`/products/${orderData.productID}`" class="title grey--text darken-3" target="_blank">
                    {{ orderData.productName }}
                </a>
            </v-col>
            <v-col cols="12" md="6" class="py-4 py-md-0 pl-0 text-left text-md-right">
                <v-btn
                    text
                    class="text--main-yellow"
                    v-if="!orderData.isOften"
                    @click="addToOften"
                >
                    {{ $t('addToOften') }}
                </v-btn>
                <v-btn
                    text
                    class="text--main-yellow"
                    v-if="orderData.isOften"
                    @click="removeOften"
                >
                    {{ $t('wantDeleteOften') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <price-info :order="orderData"></price-info>
            </v-col>
            <v-col cols="12">
                <delivery-info :order="orderData" :statuses="statusField"></delivery-info>
            </v-col>
            <v-col cols="12" v-if="orderData.contractFile || orderData.contractHistory.length">
                <contract-info :order="orderData"></contract-info>
            </v-col>
            <v-col cols="12">
                <seller-info :order="orderData"></seller-info>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="d-flex">
                <v-btn text class="text--main-yellow" :to="orderData.productUrl">
                    {{ $t('productPage') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text class="red--text" @click="remove" :disabled="!orderData.isDeletable">
                    {{ $t('remove') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ProfileService from '../../../../app-front/services/api/ProfileService';
    import ContractInfo from "./ExtendContractInfo"
    import DeliveryInfo from "./ExtendDeliveryInfo"
    import SellerInfo from "./ExtendSellerInfo"
    import PriceInfo from "../profile-sales/ExtendPriceInfo"

    export default {
        name: "BasketDataExtend",
        props: ['order', 'fields'],
        data() {
            return {
                orderData: {},
                ndsPrice: '',
            }
        },
        components: {
            ContractInfo,
            DeliveryInfo,
            PriceInfo,
            SellerInfo,
        },
        computed: {
            disabledUpdate() {
                let disabled = false;

                if(!this.orderData.quantity || !this.orderData.address || !this.orderData.price) {
                    disabled = true;
                }

                return disabled;
            },
            statusField() {
                const field = this.fields.find(item => item.name === 'statusID');

                return field || {};
            },
            price() {
                this.productNds();
                return parseInt(this.orderData.priceDiscounted) ? this.orderData.priceDiscounted : this.orderData.price;
            },
            unitValue() {
                const minValue = this.orderData.minValue || 1;
                const quantity = this.orderData.quantity || 1;

                return minValue * quantity * this.orderData.packValue + ' ' + this.orderData.unitName;
            }
        },
        methods: {
            addToOften() {
                const orders = [this.orderData.id];

                ProfileService.addToOften(orders)
                    .then(res => {
                        this.orderData.isOften = 1;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            initOrderData() {
                this.orderData = this.order;
            },
            productNds () {
                this.orderData.withNds.map(item => {
                    if (item.checked === true) {
                        if (item.title) {
                            this.ndsPrice = item.title;
                        }
                    }
                });
                return this.ndsPrice;
            },
            remove() {
                this.$emit('remove', this.orderData);
            },
            removeOften() {
                const orders = [this.orderData.id];

                ProfileService.deleteOften(orders)
                    .then(res => {
                        this.orderData.isOften = 0;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            save() {
                this.$emit('save', this.orderData);
            }
        },
        watch: {
            order() {
                this.initOrderData();
            }
        },
        created() {
            this.initOrderData();
        }
    }
</script>
